import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiDelete, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';

export const useDeletePipeline = createMutationHook<void, string>({
  mutationFn: (id) => apiDelete<void>(operationsClient, jobPipelineEndpoints.delete(id)),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.lists() });
    toast.success('Pipeline archived');
  },
});
